<template>
  <div>
    <div class="swiper-container categorias" :class="origin === '8' ? 'd-md-none' : 'd-xl-none'">
      <div class="swiper-wrapper">
        <div class="swiper-slide text-center" v-for="(c, index) in categorias" :key="index">
          <a href="javascript:" class="link-categoria" :class="{'active': c.id_categoria === categoria}"
             @click="changeMenu(c)" :aria-label="'Mostrar produtos da categoria ' + c.nome_categoria">
            <div class="card-categoria" aria-hidden="true">
              <img :src="`${base_cdn}/icones/${c.slug || 'default'}-light.svg`" :alt="c.slug" v-if="c.id_categoria === categoria">
              <img :src="`${base_cdn}/icones/${c.slug || 'default'}.svg`" :alt="c.slug" v-else>
            </div>
            <h3 class="font-weight-bold my-2 limite-1" style="font-size: 12px">{{c.nome_categoria}}</h3>
          </a>
        </div>
      </div>
    </div>
    <div class="card p-2 d-none" :class="origin === '8' ? 'd-md-block' : 'd-xl-block'">
      <div v-for="(c, index) in categorias" :key="index">
        <a href="javascript:" class="link-desktop" :class="{'active': c.id_categoria === categoria}"
           @click="changeMenu(c)" :aria-label="'Mostrar produtos da categoria ' + c.nome_categoria">
          <img :src="`${base_cdn}/icones/${c.slug || 'default'}-light.svg`" :alt="c.slug" v-if="c.id_categoria === categoria">
          <img :src="`${base_cdn}/icones/${c.slug || 'default'}.svg`" :alt="c.slug" v-else>
          <h3 class="mb-0" style="font-size: 14px">
            {{c.nome_categoria}}
          </h3>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css'
  import IconCategoria from './IconCategoria'

  export default {
    name: "carrosell",
    components: {IconCategoria},
    data () {
      return {
        categoria: '',
        swiper: ''
      }
    },

    methods: {
      changeMenu(c) {
        this.$emit('changeMenu', c, true);
      },

      changeMenuBar(cat, change) {
        this.categoria = cat;

        if (change) {
          const index = this.categorias.findIndex(c => c.id_categoria === cat);
          if (index !== -1) { this.swiper.slideTo(index); }
        }
      }
    },

    mounted() {
      this.swiper = new Swiper('.categorias', {
        slidesPerView: 'auto',
      });
    },

    computed: {
      categorias() {
        return this.$store.state.cardapio.categorias
      }
    }
  }
</script>

<style scoped>
  .swiper-container {
    width: 100%;
  }

  .swiper-slide {
    width: auto;
    font-size: 14px;
  }

  .link-categoria {
    text-decoration: none;
    color: unset;
    padding-right: 14px;
    display: block;
    width: 100px;
  }

  .card-categoria {
    border-radius: 18px;
    padding: 18px;
    background-color: #dbdcde;
    display: flex;
    justify-content: center;
  }

  .card-categoria img {
    width: 24px;
  }

  .link-categoria.active .card-categoria {
    background-color: var(--dark);
  }

  .link-desktop {
    color: #212529;
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 12px;
    margin-bottom: 2px;
  }

  .link-desktop img {
    width: 20px;
    margin-right: 8px;
  }

  .link-desktop:hover, .link-desktop:visited {
    color: var(--lecard-primary);
  }

  .link-desktop.active {
    color: #ffffff;
    background-color: var(--lecard-primary);
  }
</style>
